import React, { Component } from 'react';
import { TreeSelect } from 'antd';
import { path, prop, without, equals } from 'ramda';
import translate from 'counterpart';
import Translate from 'react-translate-component';

import withFieldWrapper from 'components/hocs/withFieldWrapper';
import withLanguageContext from 'components/hocs/withLanguageContext';
import { asyncConnect } from 'react-async-client';
import { getMetroDepartments, getMetroDepartmentChildren } from 'actions/asyncActions';
import MetroDepartmentTitle from './MetroDepartmentTitle';

const stateToProps = state => ({
    getDepartmentData: params => getMetroDepartmentChildren.withParams(params).selectData(state),
    getDepartmentMeta: params => getMetroDepartmentChildren.withParams(params).selectMeta(state)
});

@withFieldWrapper
@withLanguageContext
@asyncConnect(({ disabled }) => ({
    getMetroDepartments: getMetroDepartments
        .withPayload(prop('loadParams'))
        .withParams(prop('language'))
        .withShouldUpdate((prev, props) => (
            props.loadParams.type && (!equals(prev.loadParams, props.loadParams))
            || prev.disabled !== props.disabled
            || prev.language !== props.language
        ))
        .withOptions({ dispatchOnMount: !disabled, dispatchOnUpdate: true, resetOnUnmount: true })
}), stateToProps)
export default class MetroDepartmentSelect extends Component {
    nodes = {};
    state = {
        expandedKeys: []
    };

    onExpand = (expandedKeys) => {
        const expandedId = path([0], without(this.state.expandedKeys, expandedKeys));

        if (expandedId) {
            const action = this.getAction(expandedId);
            !action.meta.pending && !action.meta.lastSucceedAt && action.refresh();
        }

        this.setState({ expandedKeys });
    }

    getAction = id => {
        return path([id, 'props', 'getMetroDepartmentChildren'], this.nodes);
    }

    renderNodes = item => {
        const { getDepartmentData, language, loadParams } = this.props;
        const items = getDepartmentData({ language, type: loadParams.type, addCode: item.id });

        return items.length ?
            items.map(this.renderNode) :
            <TreeSelect.TreeNode
                key={`empty-${item.id}`}
                value={`empty-${item.id}`}
                title={<Translate content='metro.request.departmentsEmpty'/>}
                selectable={false}
                disabled={true}
            />
    }

    renderNode = item => {
        const { loadParams, language } = this.props;
        const childrenLoadParams = { language, type: loadParams.type, addCode: item.id };

        return <TreeSelect.TreeNode
            key={item.id}
            value={item.id}
            label={item.name}
            title={
                <MetroDepartmentTitle
                    item={item}
                    getRef={node => this.nodes[item.id] = node}
                    loadParams={childrenLoadParams}
                />
            }>
            { item.hasChildren && this.renderNodes(item) }
        </TreeSelect.TreeNode>;
    }

    onChange = (value, _, extra) => {
        this.props.onChange(value, { label: path(['triggerNode', 'props', 'label'], extra) });
    }

    render() {
        const { getMetroDepartments: { data, meta } } = this.props;
        const { input: { value, name }, valueString, allowClear, disabled } = this.props;
        const { expandedKeys } = this.state;

        return <TreeSelect
            className={name}
            getPopupContainer={() => document.querySelector(`.${name}`)}
            ref={node => this.node = node}
            treeExpandedKeys={expandedKeys}
            onTreeExpand={this.onExpand}
            onChange={this.onChange}
            value={(valueString ? undefined : value) || undefined}
            placeholder={valueString || translate('placeholders.chooseDepartment')}
            notFoundContent={translate('errors.notFound')}
            allowClear={allowClear}
            disabled={disabled || meta.pending}
            dropdownStyle={{'maxHeight': 300}}>
            { data.map(this.renderNode)}
        </TreeSelect>;
    }
}
